import "./styles.scss";

import { Fragment } from "react";
import moment from "moment-timezone";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { timeDisplayFormat } from "../../utils/utils";
import Placeholder from "../Placeholder/PlaceholderByPage";

const TableList = ({ listItems, listedItems, action }) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const TableItemRating = ({ index, item }) => (
    <td key={"tlbRowRating" + index} data-item={item.rating} className="ratingTeachers">
      <label className="label">{item.rating}</label>
    </td>
  );

  return (
    <Fragment>
      {!listedItems.length ? (
        <Placeholder pageName="users" textMsg={t("NO_RESULTS")} />
      ) : (
        listedItems.map((item, iItem) => (
          <div key={"BigBox" + iItem} className="bigBoxCards">
            <div key={"box" + iItem} className="boxItems">
              {listItems.map(({ label, name }, i) => (
                <div key={"listItem" + i} data-item={item[name]} className={`list-item list-item-${name}`}>
                  {name === "rating" && <TableItemRating name={name} item={item[name]} />}
                  {!(
                    name === "rating" ||
                    name === "button" ||
                    name === "createdAt" ||
                    name === "lastInteraction" ||
                    name === "status" ||
                    name === "role"
                  ) && (
                    <Fragment>
                      <h3>{label}</h3>
                      {name === "title" ? (
                        <p>
                          <span>{item[name].length > 30 ? item[name].substring(0, 30) + "..." : item[name]}</span>
                        </p>
                      ) : (
                        <p>
                          <span>{item[name]}</span>
                        </p>
                      )}
                    </Fragment>
                  )}

                  {(name === "role" || name === "status") && (
                    <Fragment>
                      <h3>{label}</h3>
                      <p>
                        {name === "status" ? (
                          <span
                            className={
                              item[name] === "closed"
                                ? "closed"
                                : item[name] === "open"
                                ? "open"
                                : item[name] === "inProgress"
                                ? "progress"
                                : "cancelled"
                            }
                          >
                            {t(`CARD_LIST_CUSTOM_SERVICE.${item[name]}`)}
                          </span>
                        ) : (
                          <span>{t(`CARD_LIST_CUSTOM_SERVICE.${item[name]}`)}</span>
                        )}
                      </p>
                    </Fragment>
                  )}
                  {(name === "createdAt" || name === "lastInteraction") && (
                    <Fragment>
                      <h3>{label}</h3>
                      <p>
                        <span>
                          {moment(item[name])
                            .tz(item.timezone)
                            .format(t("DATE_FORMAT") + " - " + timeDisplayFormat(user?.timeDisplayFormat))}
                        </span>
                      </p>
                    </Fragment>
                  )}

                  {name === "button" && (
                    <button className="view" onClick={() => action(item.id)}>
                      {t("VIEW")} <i className="fa fa-angle-right" aria-hidden="true" />
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </Fragment>
  );
};

export default TableList;
